var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTea = function SvgTea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tea_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    x: 16,
    y: 12,
    fill: "#fff",
    rx: 8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M28.074 44.189A8.273 8.273 0 0 0 36.29 51.5h5.42a8.27 8.27 0 0 0 8.216-7.311l.6-5.142c.075-.64.113-.961.098-1.225a3 3 0 0 0-2.47-2.776C47.895 35 47.57 35 46.925 35H31.077c-.645 0-.968 0-1.229.045a3 3 0 0 0-2.469 2.775c-.015.266.021.585.096 1.227"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeWidth: 1.5,
    d: "M49.5 45.5h3a4.501 4.501 0 0 0 1.722-8.657A4.5 4.5 0 0 0 52.5 36.5h-2.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M39 23a2.123 2.123 0 0 0 0 3 2.12 2.12 0 0 1 0 3m-7.5 2.25.174-.174c.76-.76.846-1.965.2-2.826a2.16 2.16 0 0 1 .202-2.826l.174-.174m13.5 6 .174-.174c.76-.76.846-1.965.2-2.826a2.16 2.16 0 0 1 .202-2.826l.174-.174"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tea_svg__a",
    width: 84,
    height: 84,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4483_45585"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4483_45585",
    result: "shape"
  })))));
};
export default SvgTea;